import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { l as u } from "./lodash-5ofSKtz3.mjs";
import { C as n } from "./calendar-base-D7AWCGXE.mjs";
const x = (r) => {
  const { value: a, onChange: s, disabled: d, navigation: i, startMonth: l, endMonth: m, renderDay: t, biId: c } = r;
  return /* @__PURE__ */ e.jsx(
    n,
    {
      biId: c,
      "data-fabric-component": "CalendarV2",
      disabled: d,
      endMonth: m,
      month: a ?? (/* @__PURE__ */ new Date()).toISOString(),
      navigation: i,
      onChange: s,
      renderDay: (p, o) => {
        const { disabled: b } = o;
        return u.isFunction(t) ? t(p, o) : /* @__PURE__ */ e.jsx(n.Day, { component: b ? "div" : "button" });
      },
      selectionMode: "single",
      startMonth: l,
      value: a
    }
  );
};
x.Day = n.Day;
export {
  x as C
};
//# sourceMappingURL=calendar-v2-BoqmBFJV.mjs.map
